import { Observable } from 'rxjs/Observable';
import history from '../routers/history'
import getUserEvents from '../actions/events/getUserEventsAction';
import getEventSongs from '../actions/events/getEventSongsAction';
import addEventMixpanel from '../actions/mixpanel/addEventMixpanel';


export function handleAddEventFulfilled(action$, store) {
   return action$.filter(
      action => action.type === 'ADD_EVENT_FULFILLED')
      .mergeMap(() => Observable.merge(
          Observable.of(() => history.push('/events/currentEventDetails')),
         Observable.of(getUserEvents(store.getState().user.data.objectId)),
         Observable.of(getEventSongs(store.getState().events.currentEvent.objectId)),
         Observable.of(addEventMixpanel(store.getState().events.currentEvent, store.getState().events.templateUsed))
         ));
}



// WEBPACK FOOTER //
// ./src/epics/addEventEpic.js